var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DB544B;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 100,
    height: 100
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.99,
    y: 27.24,
    className: "st1",
    width: 59.22,
    height: 44.83
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.96,
    y: 30.22,
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.57,
    y: 35.84,
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.18,
    y: 41.45,
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8,
    y: 47.06,
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46.41,
    y: 47.06,
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 71.69,
    y: 30.22,
    transform: "matrix(-1 -4.472523e-11 4.472523e-11 -1 149.0023 66.0603)",
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 66.08,
    y: 35.84,
    transform: "matrix(-1 -4.504942e-11 4.504942e-11 -1 137.7773 77.2853)",
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 60.47,
    y: 41.45,
    transform: "matrix(-1 -4.472523e-11 4.472523e-11 -1 126.5523 88.5103)",
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 54.86,
    y: 47.06,
    transform: "matrix(-1 -4.504942e-11 4.504942e-11 -1 115.3273 99.7353)",
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 49.24,
    y: 47.06,
    transform: "matrix(-1 -4.472523e-11 4.472523e-11 -1 104.1023 99.7353)",
    className: "st2",
    width: 5.61,
    height: 5.61
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 50.02,
    y: 47.2,
    transform: "matrix(-1 -4.504942e-11 4.504942e-11 -1 105.6531 100.0045)",
    className: "st2",
    width: 5.61,
    height: 5.61
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.6053217fcb03320955b27370c6ff1475.svg";
export { ForwardRef as ReactComponent };